export enum ENDPOINTS {
    LOGIN = 'login', // APP_HOST = AUTH
	REFRESH = 'refresh', // APP_HOST = AUTH
	PARENTS = 'v4/parents', // APP_HOST = PY
	GROUPS = 'v4/groups', // APP_HOST = PY
	PARENT_TIMEZONES = 'read_parent_timezones', // APP_HOST = PHP
	CREATE_PARENT = 'admin_create_pri_parent', // APP_HOST = PHP
	MODIFY_PARENT = 'admin_modify_parent', // APP_HOST = PHP
	KPI_JOB_CHATS_CREATED_DAY = 'kpi_job_chats_created_day', // APP_HOST = PHP
	READ_USERS = 'read_users', // APP_HOST = PHP
	LIST_PARENT_USER = 'admin_list_parent_user', // APP_HOST = PHP
	SAVE_PARENT_USER = 'admin_save_parent_user', // APP_HOST = PHP
	READ_GL_PARENT = 'admin_read_gl_parent', // APP_HOST = PHP
	READ_PRI_BUSINESS = 'admin_read_pri_business', // APP_HOST = PHP
	GROUP = 'group', // APP_HOST = PY,
	MODIFY_BUSINESS = 'modify_pri_business', // APP_HOST = PHP
	CREATE_BUSINESSES = 'admin_create_businesses_v2', // APP_HOST = PHP
	COPY_GROUP_DATA = 'copy-group-data', // APP_HOST = PY
	READ_PRI_USER_BUSINESS = 'admin_read_pri_user_business_v2', // APP_HOST = PY
	CHECK_USER = 'admin_check_user', // APP_HOST = PHP
	SAVE_USER = 'admin_save_user', // APP_HOST = PHP
	SAVE_USERS = 'admin_save_users', // APP_HOST = PHP
	SAVE_PRI_USER_BUSINESS = 'save_pri_user_business_v2', // APP_HOST = PHP
	CREATE_JOBS = 'admin_create_jobs', // APP_HOST = PHP
	RANDOM_JOBS = 'v4/random-jobs', // APP_HOST = PY
	READ_GROUP_TAG_SETTINGS = 'admin_read_group_tag_settings', // APP_HOST = PHP
	UPDATE_GROUP_TAG_SETTINGS = 'admin_update_group_tag_settings', // APP_HOST = PHP
	READ_JOBS = 'admin_read_jobs', // APP_HOST = PHP
	CREATE_CHECKLIST = 'admin_create_checklist', // APP_HOST = PHP
	RESET_USER_PASSWORD = 'admin_reset_user_password', // APP_HOST = PHP
	USERS = 'v4/users', // APP_HOST = PY
	SAVE_PRI_USER = 'save_pri_user_v7', // APP_HOST = PHP
	CREATE_TEMP_PASSWORD = 'create_temp_password', // APP_HOST = PHP
	LIST_JOBS = 'webcust_list_jobs', // APP_HOST = PHP(Include Web)
	MIGRATE_JOB_VALIDATE = 'migrate_job_v1_validate', // APP_HOST = PHP
    MIGRATE_JOB = 'migrate_job_v1', // APP_HOST = PHP
    CURRENCIES_LIST = 'currencies_list', // APP_HOST = PHP
    CREATE_PACKAGE = 'admin_create_package', // APP_HOST = PHP
    READ_STRIPE_PRODUCTS = 'admin_read_stripe_products_v3', // APP_HOST = PHP
    CREATE_STRIPE_PRODUCT = 'admin_create_stripe_product_v3', // APP_HOST = PHP
	SNAPFIX_BUNDLES = 'snapfix_bundles', // APP_HOST = PHP
    SNAPFIX_PACKAGES = 'snapfix_packages', // APP_HOST = PHP
    CREATE_SNAPFIX_PACKAGE = 'create_snapfix_package', // APP_HOST = PHP
    UPDATE_PACKAGE_SCHEMA = 'update_package_schema', // APP_HOST = PHP
    PARENT_PACK = 'v4/parent-pack', // APP_HOST = PY
    SUPPORT_HOURS = 'support-hours', // APP_HOST = PY, support-hours/{{ accountId }}
	LIST_TEMPLATES_JWT = 'webcust_list_templates_jwt', // APP_HOST = PHP(Include Web)
	ONBOARD_PARENT = 'admin_onboard_parent', // APP_HOST = PHP
	JOB_GEO_STATS = 'job_geo_stats', // APP_HOST = PHP
	DASHBOARD_PARENTS = 'admin_dashboard_parents', // APP_HOST = PHP
    GUESTLINE_PARENTS = 'guestline-parents', // APP_HOST = PY
    GUESTLINE_PARENT = 'guestline-parent', // APP_HOST = PY
    GUESTLINE_PARENT_GROUPS = 'guestline-parent/$1/businesses', // APP_HOST = PY, guestline-parent/{{ accountId }}/businesses
	GUESTLINE_LOGIN = 'admin_guestline_login', // APP_HOST = PHP
	GUESTLINE_STATUSES = 'admin_guestline_statuses', // APP_HOST = PHP
	MODIFY_GUESTLINE_PARENT = 'admin_modify_gl_parent', // APP_HOST = PHP
    CS_DASHBOARD = 'cs-dashboard', // APP_HOST = PY
	CS_DASHBOARD_ACTIVITY_REPORT = 'kpi_job_chats_created_day_xlsx_v2_webadmin', // APP_HOST = PHP
	CS_DASHBOARD_USER_LIST_REPORT = 'paying_sales_trial_account_users_webadmin', // APP_HOST = PHP
	COUNTRIES_LIST = 'countries_list',  // APP_HOST = PHP
	CREATE_ASSETS = 'admin_create_assets', // APP_HOST = PHP
	SAVE_IMAGE = 'save_image', // APP_HOST = PHP
	LIST_MKT_POPUP = 'admin_list_mkt_popup', // APP_HOST = PHP
	CREATE_MKT_POPUP = 'admin_create_mkt_popup', // APP_HOST = PHP
	MKT_POPUP_DETAIL = 'admin_mkt_popup_detail', // APP_HOST = PHP
	MODIFY_MKT_POPUP = 'admin_modify_mkt_popup', // APP_HOST = PHP
	DELETE_MKT_POPUP = 'admin_delete_mkt_popup', // APP_HOST = PHP
	QR_FORM = 'qr-form', // APP_HOST = PHP_LARAVEL, qr-form/{{ qr uuid }}, qr-form?businessUuid={{ group uuid }}
	UPLOAD_GROUPS_USERS = 'user-relations/multiple', // APP_HOST = PHP_LARAVEL
	SCHEDULE_UPLOAD = 'schedule-upload', // APP_HOST = PY
	ORGANIZATION_ACCOUNT = 'organizations/account', // APP_HOST = PHP_LARAVEL, organization/account/{{ name }}, name=hubspot|stripe|xero
	ORGANIZATION_ACCOUNT_CONNECT = 'organizations/$1/connect-account', // APP_HOST = PHP_LARAVEL, $1 = organization_uuid
	ORGANIZATION_ACCOUNT_DISCONNECT = 'organizations/$1/disconnect-account', // APP_HOST = PHP_LARAVEL, $1 = organization_uuid
	ORGANIZATION_PARENT_CONNECT = 'parents/$1/connect-organization', // APP_HOST = PHP_LARAVEL, $1 = parent_uuid
	ORGANIZATION_PARENT_DISCONNECT = 'parents/$1/disconnect-organization', // APP_HOST = PHP_LARAVEL, $1 = parent_uuid
	ORGANIZATIONS = 'organizations', // APP_HOST = PHP_LARAVEL
	DEALS = 'sales/deals', // APP_HOST = PHP_LARAVEL
	COMPANY_SUBSCRIPTIONS = 'sales/company-subscriptions', // APP_HOST = PHP_LARAVEL
	COMPANY_CHECKOUT = 'sales/company-stripe-checkout', // APP_HOST = PHP_LARAVEL
	STRIPE_CUSTOMER = 'sales/stripe-customer', // APP_HOST = PHP_LARAVEL
	GOCARDLESS_CUSTOMER = 'sales/gocardless-customer', // APP_HOST = PHP_LARAVEL
	GOCARDLESS_CUSTOMER_MANDATE = 'sales/gocardless-customer-mandate', // APP_HOST = PHP_LARAVEL
	GOCARDLESS_PAYMENTS = 'sales/gocardless-payments', // APP_HOST = PHP_LARAVEL
	COMPANY_GOCARDLESS_CHECKOUT = 'sales/company-gocardless-checkout', // APP_HOST = PHP_LARAVEL
	ONBOARDING = 'sales/onboarding', // APP_HOST = PHP_LARAVEL
	SURVEY = 'survey', // APP_HOST = PHP_LARAVEL
	USER_RELATIONS_MULTIPLE = 'user-relations/multiple',  // APP_HOST = PHP_LARAVEL
	SMS_DELIVERY = 'sms-logs', // APP_HOST = PY
	EMAIL_DELIVERY = 'email-logs', // APP_HOST = PY
}

export enum APP_HOST {
    AUTH = 'authUrl',
    PY = 'pyUrl',
    PHP = 'phpUrl',
	PHP_LARAVEL = 'phpLaravelUrl'
}